module.exports = __webpack_public_path__ + "static/img/female-bg-en.6ae8ecf4.png";